module.exports = __webpack_public_path__ + "img/leadership_img.1d5f3dc5.png";